import { Spinner } from "@blueprintjs/core";
import React from "react";
import ReactDOM from "react-dom";
import styles from "./SavingOverlay.module.scss";

/**
 * Заслонка на время сохранения — поверх всего приложения.
 *
 * Свой оверлей вместо Loader: тот рендерится через Blueprint Overlay, а его портал
 * сидит на z-index 20 из темы, и панели вроде строки сохранения оказываются выше.
 * Поднимать z-index у самого портала нельзя — он общий для всех диалогов.
 */
export const SavingOverlay: React.FC<{ text?: string }> = ({ text }) =>
    ReactDOM.createPortal(
        <div className={styles.overlay}>
            {text && <div className={styles.text}>{text}</div>}
            <Spinner intent="primary" />
        </div>,
        document.body
    );
